module.exports = "<p>cubique works!</p>\n"